import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
  LayoutDashboard,
  BrainCircuit,
  FlaskConical,
  Database,
  Settings,
  ChevronDown,
  Sprout,
  AlertTriangle,
  TrendingUp,
  Users,
  ShoppingBag,
  Target,
  DollarSign,
  Star,
  BarChart3,
  Repeat,
  Clock,
  Gift,
  ArrowUpCircle,
  Heart,
  Zap,
} from 'lucide-react';

const modelGroups = [
  {
    label: 'Core Models',
    items: [
      { path: '/models/churn-risk', label: 'Churn Risk', icon: AlertTriangle },
      { path: '/models/revenue-forecast', label: 'Revenue Forecast', icon: TrendingUp },
      { path: '/models/tier-migration', label: 'Tier Migration', icon: ArrowUpCircle },
      { path: '/models/campaign-response', label: 'Campaign Response', icon: Target },
    ],
  },
  {
    label: 'Customer Scoring',
    items: [
      { path: '/models/decliner-detection', label: 'Decliner Detection', icon: BarChart3 },
      { path: '/models/rising-star', label: 'Rising Star', icon: Star },
      { path: '/models/near-harvest', label: 'Near Harvest', icon: Gift },
      { path: '/models/vip-likely', label: 'VIP Likely', icon: Heart },
      { path: '/models/clv', label: 'Customer Lifetime Value', icon: DollarSign },
    ],
  },
  {
    label: 'Basket & Product',
    items: [
      { path: '/models/basket-recommendation', label: 'Basket Recommendation', icon: ShoppingBag },
      { path: '/models/upsell-recommendation', label: 'Upsell Recommendation', icon: Zap },
      { path: '/models/cross-sell-recommendation', label: 'Cross-Sell', icon: Repeat },
      { path: '/models/replenishment-predictor', label: 'Replenishment Predictor', icon: Clock },
    ],
  },
];

export default function Sidebar() {
  const location = useLocation();
  const [openSections, setOpenSections] = useState({ models: true });

  const toggle = (key) =>
    setOpenSections((prev) => ({ ...prev, [key]: !prev[key] }));

  const isModelsActive = location.pathname.startsWith('/models');

  return (
    <aside className="sidebar">
      <div className="sidebar-brand">
        <h2>
          <Sprout size={18} style={{ marginRight: 6, verticalAlign: 'middle', color: 'var(--primary)' }} />
          Folio Coffee Co.
        </h2>
        <span>CRM Intelligence</span>
      </div>

      <nav className="sidebar-nav">
        <div className="nav-group">
          <NavLink to="/" end className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}>
            <LayoutDashboard className="nav-icon" size={18} />
            Dashboard
          </NavLink>
        </div>

        <div className="nav-group">
          <div
            className={`nav-item${isModelsActive ? ' active' : ''}`}
            onClick={() => toggle('models')}
            style={{ cursor: 'pointer' }}
          >
            <BrainCircuit className="nav-icon" size={18} />
            Predictive Models
            <ChevronDown size={14} className={`nav-toggle${openSections.models ? ' open' : ''}`} />
          </div>

          <div
            className="nav-sub-items"
            style={{ maxHeight: openSections.models ? '800px' : '0' }}
          >
            {modelGroups.map((group) => (
              <div key={group.label}>
                <div className="nav-group-label">{group.label}</div>
                {group.items.map((item) => (
                  <NavLink
                    key={item.path}
                    to={item.path}
                    className={({ isActive }) => `nav-sub-item${isActive ? ' active' : ''}`}
                  >
                    <item.icon size={14} />
                    {item.label}
                  </NavLink>
                ))}
              </div>
            ))}
          </div>
        </div>

        <div className="nav-group">
          <NavLink to="/test-learn" className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}>
            <FlaskConical className="nav-icon" size={18} />
            Test &amp; Learn
          </NavLink>
        </div>

        <div className="nav-group">
          <NavLink to="/data-manager" className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}>
            <Database className="nav-icon" size={18} />
            Data Manager
          </NavLink>
        </div>

        <div className="nav-group">
          <NavLink to="/settings" className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}>
            <Settings className="nav-icon" size={18} />
            Settings
          </NavLink>
        </div>
      </nav>

      <div className="sidebar-footer">
        Powered by <strong style={{ color: 'var(--secondary)' }}>Hahn AI</strong>
      </div>
    </aside>
  );
}
